import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Select
import Select from "react-select";

// Helpers
import Helpers from '../helpers';

// Components
import FunctionalButton from './Buttons/FunctionalButton';

// Interfaces
interface Features {
    inputs: any;
    sendFunction: (resetStatus: boolean) => void;
    store: any;
    inFilters?: any;
    deleteInFilterElement?: any;
    alert_text?: any;
    autoSend?: boolean;
    uniqText?: any;
}

@inject('AuthStore')
@observer

export default class SearchForm extends React.Component<Features> {
    state: any = {
        filters: {},
        filterText: "",
        refs: null,
        dateBetweens: {},
        uniqText: ""
    };

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        this.setRefs();

        if (this.props.uniqText !== undefined) {
            this.setState({ uniqText: this.props.uniqText });
        }
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.uniqText !== undefined) {
            if (this.state.uniqText !== this.props.uniqText) {
                this.resetForm();
                this.setState({ uniqText: this.props.uniqText })
            }
        }
    }

    setRefs = async () => {
        const refs = {};

        await Promise.all(this.props.inputs.map(async (input: any) => {
            if (input.type !== "dateBetween") {
                refs[input.name] = {
                    type: input.type,
                    ref: React.createRef()
                };
            } else {
                refs[input.name] = {
                    type: input.type,
                    refs: {}
                };
                refs[input.name]['refs'][0] = React.createRef();
                refs[input.name]['refs'][1] = React.createRef();
            }
        }));

        this.setState({ refs })
    }

    setFiltersValue = async (input: any, value: any, autoSend: any) => {
        const filterInputs = this.state.filters;

        if (input.type === "selectMulti") {
            // Çoklu seçimlerde value bir dizi olarak alınır
            filterInputs[input.name] = {
                ...input,
                value: value.map((item: any) => item.value), // Sadece value değerlerini al
                labels: value.map((item: any) => item.label), // Etiketleri ayrı tutmak için ekledik
            };

            if (value.length === 0) {
                // Eğer seçim boşsa filtreyi kaldır
                delete filterInputs[input.name];
            }
        } else {
            // Diğer türler için mevcut mantık
            filterInputs[input.name] = {
                ...input,
                value,
            };

            if (input.type === "text" && value === "") {
                delete filterInputs[input.name];
            }

            if (input.type === "select" && value === "") {
                delete filterInputs[input.name];
            }
        }

        this.setState({ filters: filterInputs });

        if (autoSend) {
            setTimeout(() => {
                this.sendForm();
            }, 500);
        }
    };

    setDateBetween = (name: string, type: string, value: any, autoSend: boolean) => {
        const dateBetweens = this.state.dateBetweens;

        if (dateBetweens[name] === undefined) {
            dateBetweens[name] = {
                name,
                startDate: null,
                endDate: null
            }
        }

        if (value !== "") {
            dateBetweens[name][type] = value;
        } else {
            dateBetweens[name][type] = null;
        }

        this.setState({ dateBetweens });

        if (autoSend) {
            setTimeout(() => {
                this.sendForm();
            }, 500);
        }
    }

    sendForm = async () => {
        let filterText = "";
        let index = 0;

        await Promise.all(Helpers.objectToArray(this.state.filters).map(async (filter: any) => {
            if (filter.type === "text") {
                filterText = filterText + `&filters[${filter.name}][$contains][${index}]=` + filter.value;
            }

            if (filter.type === "textInRelation") {
                filterText = filterText + `&filters[${filter.relation}][${filter.name}][$contains][${index}]=` + filter.value;
            }

            if (filter.type === "select") {
                filterText = filterText + `&filters[${filter.name}][${filter.findColumn}][${index}]=` + filter.value;
            }

            if (filter.type === "selectMulti") {
                filter.value.map((option: any) => {
                    filterText = filterText + `&filters[${filter.name}][${filter.findColumn}][${index}]=` + option;
                    index = index + 1;
                })
            } else {
                index = index + 1;
            }
        }));

        await Promise.all(Helpers.objectToArray(this.state.dateBetweens).map(async (between: any) => {
            if (between.startDate !== null && between.endDate !== null) {
                if (between.startDate === between.endDate) {
                    filterText = filterText + `&filters[${between.name}][$contains][${index}]=${between.startDate}`;
                } else {
                    filterText = filterText + `&filters[${between.name}][$between]=${between.startDate}&filters[${between.name}][$between]=${between.endDate}`;
                }
            } else {
                filterText = filterText + `&filters[${between.name}][$contains][${index}]=${between.startDate}`;
            }

            index = index + 1;
        }));

        if (filterText !== this.state.filterText) {
            const deleteTitles: any = [];

            if (this.props.deleteInFilterElement !== undefined) {
                await Promise.all(this.props.deleteInFilterElement.map(async (filterElement: any) => {
                    if (filterText.includes(filterElement)) {
                        deleteTitles.push(filterElement);
                    }
                }));
            }

            let inFilterText = "";

            if (this.props.inFilters !== undefined) {
                await Promise.all(this.props.inFilters.map(async (inFilter: any) => {
                    let deleteItemStatus = false;

                    if (this.props.deleteInFilterElement !== undefined) {
                        await Promise.all(deleteTitles.map(async (deleteTitle: any) => {
                            deleteItemStatus = inFilter.includes(deleteTitle);
                        }));
                    }

                    if (!deleteItemStatus) {
                        inFilterText = inFilterText + '&' + inFilter.replace("changeIndex", index);
                        index = index + 1;
                    }
                }));
            }

            filterText = filterText + inFilterText;

            this.props.store.setSearchFilterText(filterText);
            this.props.sendFunction(true);
        }

        this.setState({ filterText });
    }

    resetForm = () => {
        Helpers.objectToArray(this.state.refs).forEach((ref: any) => {
            if (ref.type !== "dateBetween") {
                ref.ref.current.value = "";

                if (ref.type === "selectMulti") {
                    ref.ref.current.setValue([])
                }

                if (ref.type === "select") {
                    ref.ref.current.setValue({ value: "", label: "" })
                }
            } else {
                ref.refs[0].current.value = "";
                ref.refs[1].current.value = "";
            }

            this.setState({ dateBetweens: {}, filters: {}, filterText: "" })
            this.props.store.setSearchFilterText("");
        })
    }

    render() {
        const autoSend = this.props.autoSend !== undefined ? this.props.autoSend : false;

        return (
            <div>
                <div className="mb-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-2">
                    {
                        this.state.refs !== null &&
                        this.props.inputs.map((input: any, index: number) => {
                            return (
                                <div key={index} className="w-full">
                                    <label>{input.placeholder}</label>

                                    {
                                        input.type === "text" &&
                                        <input
                                            type="text"
                                            ref={this.state.refs[input.name].ref}
                                            onChange={async (element: any) => await this.setFiltersValue(input, element.target.value, autoSend)}
                                            className="border border-gray-300 w-full p-1.5 rounded placeholder:text-black"
                                        />
                                    }

                                    {
                                        input.type === "textInRelation" &&
                                        <input
                                            type="text"
                                            ref={this.state.refs[input.name].ref}
                                            onChange={async (element: any) => await this.setFiltersValue(input, element.target.value, autoSend)}
                                            className="border border-gray-300 w-full p-1.5 rounded placeholder:text-black"
                                        />
                                    }

                                    {
                                        input.type === "selectMulti" &&
                                        <Select
                                            ref={this.state.refs[input.name].ref}
                                            onChange={(value) =>
                                                this.setFiltersValue(input, value, autoSend)
                                            }
                                            options={input.options}
                                            isMulti
                                        />
                                    }

                                    {
                                        input.type === "select" &&
                                        <Select
                                            ref={this.state.refs[input.name].ref}
                                            onChange={(value: any) =>
                                                this.setFiltersValue(input, value.value, autoSend)
                                            }
                                            options={input.options}
                                        />
                                    }

                                    {
                                        input.type === "dateBetween" &&
                                        <div className="grid grid-cols-2 gap-x-2">
                                            <input
                                                type="date"
                                                ref={this.state.refs[input.name].refs[0]}
                                                onChange={async (element: any) => this.setDateBetween(input.name, "startDate", element.target.value, autoSend)}
                                                className="border border-gray-300 w-full p-1.5 rounded placeholder:text-black"
                                            />

                                            <input
                                                type="date"
                                                ref={this.state.refs[input.name].refs[1]}
                                                onChange={async (element: any) => this.setDateBetween(input.name, "endDate", element.target.value, autoSend)}
                                                className="border border-gray-300 w-full p-1.5 rounded placeholder:text-black"
                                            />
                                        </div>
                                    }
                                </div>
                            )
                        })
                    }
                </div>

                {
                    this.props.alert_text !== undefined &&
                    <div className="text-sm text-primary mb-2">
                        {this.props.alert_text}
                    </div>
                }

                <div className="flex flex-row justify-end">
                    <div className={`${!autoSend && 'grid grid-cols-2 gap-x-2'} w-full md:w-2/4 xl:w-1/4 flex`}>
                        <FunctionalButton
                            onPress={() => this.resetForm()}
                            text={Helpers.translation("clean")}
                            rounded
                        />

                        {
                            !autoSend &&
                            <FunctionalButton
                                onPress={() => this.sendForm()}
                                text={Helpers.translation("filter")}
                                rounded
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}